

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Units',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formdatatable',
                            attributes: {
                                placeholder:"Units",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'units/UNIT_SET_UNIT',                                    
                                items:'units/units',
                                withcheck:false,
                                withsearch:true,
                                withdialog:false,
                                headers: [
                                    {
                                        text: 'Name',
                                        value: 'name',
                                        sortable:false
                                    },    
                                    
                                ]
                            }                                    
                        }
                    ],                   
                ]
            },
        },        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};